var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckmarkGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16.01,
    viewBox: "0 0 16 16.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10607",
    transform: "translate(-533 -416)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 3069",
    cx: 7.006,
    cy: 7.005,
    rx: 7.006,
    ry: 7.005,
    transform: "translate(534 417)",
    style: {
      fill: "#30c48d"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10606"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 91661",
    d: "m13.2 10.2-1.7 2.5-.5-.5a.99.99 0 0 0-1.4 1.4L11 15a.908.908 0 0 0 .7.3h.1a.842.842 0 0 0 .7-.4l2.4-3.6a1.012 1.012 0 1 0-1.7-1.1z",
    transform: "translate(528.953 411.862)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 91662",
    d: "M17.049 7.764a1.58 1.58 0 0 1-.48-1.121 3.211 3.211 0 0 0-3.2-3.2 1.58 1.58 0 0 1-1.121-.48 3.189 3.189 0 0 0-4.563 0 1.291 1.291 0 0 1-1.041.48 3.211 3.211 0 0 0-3.2 3.2 1.58 1.58 0 0 1-.48 1.121 3.189 3.189 0 0 0 0 4.563 1.58 1.58 0 0 1 .48 1.121 3.211 3.211 0 0 0 3.2 3.2 1.58 1.58 0 0 1 1.121.48A3.44 3.44 0 0 0 10 18.01a3.029 3.029 0 0 0 2.241-.961 1.58 1.58 0 0 1 1.121-.48 3.211 3.211 0 0 0 3.2-3.2 1.913 1.913 0 0 1 .4-1.121 3.032 3.032 0 0 0 .087-4.484zm-1.121 3.362a3.161 3.161 0 0 0-.961 2.241 1.606 1.606 0 0 1-1.6 1.6 2.907 2.907 0 0 0-2.241.961 1.547 1.547 0 0 1-2.241 0 3.161 3.161 0 0 0-2.241-.961 1.606 1.606 0 0 1-1.6-1.6 2.907 2.907 0 0 0-.961-2.241 1.548 1.548 0 0 1 0-2.241 3.161 3.161 0 0 0 .961-2.241 1.606 1.606 0 0 1 1.6-1.6 2.907 2.907 0 0 0 2.241-.961 1.548 1.548 0 0 1 2.241 0 3.161 3.161 0 0 0 2.241.961 1.606 1.606 0 0 1 1.6 1.6 2.907 2.907 0 0 0 .961 2.241 1.548 1.548 0 0 1 0 2.241z",
    transform: "translate(531 414)",
    style: {
      fill: "#30c48d"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkGreen);
export default __webpack_public_path__ + "static/media/checkmark-green.svg";
export { ForwardRef as ReactComponent };